module.exports = __webpack_public_path__ + "img/weitu.23b8670.png";